'use strict';

angular.module('AcaApp').factory('UserService',
[
  'UserResource',
  function(UserResource){
    return {
      getUsers: function(){
        var rpcConfig = {method: 'FindUsersBySegHash', params: []};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      setProfile: function(profiles){
        if(profiles.length === undefined) {
          return;
        }
        var acaProfiles = [
          {name: 'CNV_ACAADMIN', description: 'Administrator'},
          {name: 'CNV_ACA', description: 'Editor'},
          {name: 'CNV_ACARO', description: 'View Only'},
          {name: 'CNV_ACASOVOS', description: 'User is able to send email'}
        ];
        var profileName;
        for(var i=0; i<profiles.length; i++){
          profileName = profiles[i].ProfileName;
          for(var j=0; j<acaProfiles.length; j++){
            if(acaProfiles[j].name === profileName){
              return acaProfiles[j];
            }
          }
        }
        return profiles;
      },
      deleteUser: function(userName){
        var rpcConfig = {method: 'DeleteUser', params: [userName]};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      updateUserRealName: function(userName, realName){
        var rpcConfig = {method: 'UpdateUserRealName', params: [userName, realName]};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      updateProfiles: function(userName, profileName){
        var rpcConfig = {method: 'UpdateProfiles', params: [userName, profileName]};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      updatePhone: function(userName, phone, sendOtpCode){
        var rpcConfig = {method: 'UpdatePhoneNumber', params: [userName, phone, sendOtpCode]};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      addNewUser: function(userName, realName, profileName){
        var rpcConfig = {method: 'AddUser',params: [userName, realName, "", profileName]};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      updateFullUser: function(token, userObject){
        var rpcConfig = {method: '_FinalizeUserRegistration',params: [token, userObject]};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      FindClient: function(){
        var rpcConfig = {method: 'FindClient', params: []};
        return UserResource.executeRpc(rpcConfig).$promise;
      },
      findDataToApprove: function(requestParam){
        var rpcConfig = {method: 'FindDataMSToApprove', params: [requestParam]};
        return UserResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);
